import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";
import Utils from "@/mixins/Utils";

const REPORT = 'report';
const AGENTS = '/agents';
const QUEUES = '/queues';
const CDR = 'cdr';

export default {
    mixins: [SessionApi, Utils],
    methods: {
        async getAgents() {
            const url = `${baseURL}${REPORT}${AGENTS}`
            const response = await this.httpSession().get(url)
            console.debug('[REPORT][getAgents] RESPONSE', response.data)
            return response.data;
        },
        async getQueues() {
            const url = `${baseURL}${REPORT}${QUEUES}`
            const response = await this.httpSession().get(url)
            console.debug('[REPORT][getQueues] RESPONSE', response.data)
            return response.data;
        },
        async getReportNodes() {
            const url = `${baseURL}${REPORT}/nodes`
            const response = await this.httpSession().get(url)
            console.debug('[REPORT][getReportNodes] RESPONSE', response.data)
            return response.data;
        },
        async getReport(data) {
            const url = `${baseURL}${REPORT}`
            const response = await this.httpSession().get(url, {params: data, responseType: "blob"})
            console.debug('[REPORT][getReport] RESPONSE', response)
            return response
        },
        async visualizeCDRReport(reportBean) {
            const url = `${baseURL}${CDR}/callDetailReport`; 
            
            try {
                const response = await this.httpSession().post(url, reportBean); // Enviar como JSON en el cuerpo
                console.debug('[REPORT][viewReport] RESPONSE', response.data);
                return response.data; 
            } catch (error) {
                console.error('[REPORT][viewReport] API call error:', error);
                throw error; 
            }
        }
        
        
    },



};
